import { combineReducers } from "redux";
import authReducer from "./modules/auth/reducer";
import subscriptionPlanReducer from "./modules/subscriptionWeb/reducer";
import subscriptionAdminReducer from "./modules/subscriptionAdmin/reducer";
import subscriptionOrderReducer from "./modules/ordersAdmin/reducer";
import companyReducer from "./modules/company/reducer";
import couponReducer from "./modules/coupon/reducer";
import dashboardReducer from "./modules/dashboard/reducer";
import changeStateReducer from "./changeStateReducer";
import userReducer from "./modules/users/reducers";
import CorporateAdminReducer from "./modules/CorporatePlan/reducer";
import SendNotificationsReducer from "./modules/SendNotifications/reducer";

export default combineReducers({
  auth: authReducer,
  subscription: subscriptionPlanReducer,
  subscriptionAdmin: subscriptionAdminReducer,
  subscriptionOrder: subscriptionOrderReducer,
  company: companyReducer,
  coupon: couponReducer,
  dashboard: dashboardReducer,
  changeState: changeStateReducer,
  user: userReducer,
  CorporateAdmin: CorporateAdminReducer,
  sendNotification: SendNotificationsReducer
});
